import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from '../../locales/es/common.json';
import home from '../../locales/es/home.json';
import guides from '../../locales/es/guides.json';
import guideDetail from '../../locales/es/guideDetail.json';
import rules from '../../locales/es/rules.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common,
        home,
        guides,
        guideDetail,
        rules,
      },
    },
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'common',
    initImmediate: false,
  });

export default i18n;
